import ClosetActionRTC from "../ClosetActions/ClosetActionRTC";
import ClosetActionSent from "../ClosetActions/ClosetActionSent";
import ClosetActionReceived from "../ClosetActions/ClosetActionReceived";
import ClosetActionPostReturned from "../ClosetActions/ClosetActionPostReturned";

function ClosetAction({ closet }) {
  function renderClosetAction() {
    switch (closet?.state) {
      case "ready_to_change":
        return <ClosetActionRTC />;
      case "sent":
        return <ClosetActionSent closet={closet} />;
      case "received":
        return <ClosetActionReceived closet={closet} />;
      case "post_returned":
        return <ClosetActionPostReturned closet={closet} />;
      default:
        return null;
    }
  }

  return <div>{renderClosetAction()}</div>;
}

export default ClosetAction;
